import { ClientConfig } from '../types/profile';
import { jetownConfig } from './jetown.config';
import { demoClientConfig } from './demo.config';
import { mgrConfig } from './mgr.config';

export const CLIENT_REGISTRY: Record<string, ClientConfig> = {
  jetown: jetownConfig,
  demo: demoClientConfig,
  mgr: mgrConfig,
};

export function getClientConfig(clientId?: string): ClientConfig {
  if (clientId && CLIENT_REGISTRY[clientId]) {
    return CLIENT_REGISTRY[clientId];
  }
  return jetownConfig;
}

/**
 * Deterministic hostname resolution:
 * 1. Query param override (?client=mgr, ?client=jetown) - vital for testing & internal validation
 * 2. Hostname matches
 *    - profile.mgrmix.com / mgrmix.com -> 'mgr'
 *    - profile.jetown.net / jetown.net -> 'jetown'
 * 3. Default fallback -> 'jetown'
 */
export function resolveClientIdFromHostname(
  hostname?: string,
  searchParams?: URLSearchParams
): string {
  if (searchParams) {
    const override = searchParams.get('client');
    if (override && CLIENT_REGISTRY[override]) {
      return override;
    }
  }

  if (hostname) {
    const cleanHost = hostname.toLowerCase();
    if (cleanHost.includes('mgrmix.com')) {
      return 'mgr';
    }
    if (cleanHost.includes('jetown.net')) {
      return 'jetown';
    }
  }

  return 'jetown';
}

export { jetownConfig, demoClientConfig, mgrConfig };



